import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FabricanteService } from 'src/app/services/fabricante.service';
import { Fabricante } from 'src/app/models/fabricante.model';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { GLOBAL } from '../../../services/global';
import { rest } from 'lodash';
import { FollowService } from 'src/app/services/follow.service';
import { MetricaService } from 'src/app/services/metrica.service';

@Component({
  selector: 'app-info-fabricante',
  templateUrl: './info-fabricante.component.html',
  styleUrls: ['./info-fabricante.component.css']
})
export class InfoFabricanteComponent implements OnInit {

  arrayBotones = [];
  arrayFiltros = [];
  id: any;
  slug: any;
  closeResult: string;
  url = "";
  follow: boolean;
  userLogin: any;
  resultInsertFollow: any;
  urlContactoWhatsapp: string = "";
  pos: any = null;
  pantallaCarga: boolean = false;
  iconRuta: string = "/assets/icons/ruta_info.png";

  @Input() fabricante: any;

  constructor(
    private route: ActivatedRoute,
    private fService: FabricanteService,
    private modalService: NgbModal,
    private filService: FollowService,
    private mService: MetricaService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.url = GLOBAL.url;
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    this.route.params.subscribe(result => {
      // this.arrayBotones = GLOBAL.arrayBotonesFabri(result.id);
      // this.id = result.id;
      this.arrayBotones = GLOBAL.arrayBotonesFabri(result.slug);
      this.slug = result.slug;
    });
    
  }

  llamar(telefono: string) {
    window.open('tel:' + telefono, '_blank');
  }


  navegarWebsite() {

    let url = "";

    if (this.fabricante.website.indexOf("https://") !== -1) {
      url = this.fabricante.website;
    } else {
      url = "https://" + this.fabricante.website;
    }

    window.open(url, '_blank');
  }


}
